<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="jobCategories" formControlName="jobCategory" optionLabel="name"
            optionValue="value" placeholder="Select Job Category"></p-dropdown>
            <label for="Select Job Category">Select Job Category</label>
            @for (validation of validationMessages.jobCategory; track validation) {
              <span>
                @if (form1.get('jobCategory').hasError(validation.type) && (form1.get('jobCategory').dirty || form1.get('jobCategory').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="jobLevels" formControlName="jobLevel" optionLabel="name"
            optionValue="value" placeholder="Select Job Level"></p-dropdown>
            <label for="Select Job Level">Select Job Level</label>
            @for (validation of validationMessages.jobLevel; track validation) {
              <span>
                @if (form1.get('jobLevel').hasError(validation.type) && (form1.get('jobLevel').dirty || form1.get('jobLevel').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locationCategories" formControlName="locationId" optionLabel="name"
            optionValue="locationId"></p-dropdown>
            <label for="Select Location">Select Location</label>
            @for (validation of validationMessages.locationId; track validation) {
              <span>
                @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="jobTitle" id="jobTitle" type="text" pInputText>
            <label for="jobTitle">Job Title</label>
            @for (validation of validationMessages.jobTitle; track validation) {
              <span>
                @if (form1.get('jobTitle').hasError(validation.type) && (form1.get('jobTitle').dirty || form1.get('jobTitle').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="opsNotes"><strong>Job Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="jobDesc" id="jobDesc" [config]="{uiColor: '#99000'}" debounce="500" (ready)="onReady($event)" appendTo="body"></ckeditor> -->
            <editor
              formControlName="jobDesc"
              id="jobDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.jobDesc; track validation) {
              <span>
                @if (form1.get('jobDesc').hasError(validation.type) && (form1.get('jobDesc').dirty || form1.get('jobDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <h6>Address</h6>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreetNumber" id="adrStreetNumber" type="text" pInputText>
            <label for="adrStreetNumber">Street Number</label>
            @for (validation of validationMessages.adrStreetNumber; track validation) {
              <span>
                @if (form1.get('adrStreetNumber').hasError(validation.type) && (form1.get('adrStreetNumber').dirty || form1.get('adrStreetNumber').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrStreetName" id="adrStreetName" type="text" pInputText>
            <label for="adrStreetName">Street Name</label>
            @for (validation of validationMessages.adrStreetName; track validation) {
              <span>
                @if (form1.get('adrStreetName').hasError(validation.type) && (form1.get('adrStreetName').dirty || form1.get('adrStreetName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrUnit" id="adrUnit" type="text" pInputText>
            <label for="adrUnit">Unit</label>
            @for (validation of validationMessages.adrUnit; track validation) {
              <span>
                @if (form1.get('adrUnit').hasError(validation.type) && (form1.get('adrUnit').dirty || form1.get('adrUnit').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adr2" id="adr2" type="text" pInputText>
            <label for="adr2">Address 2</label>
            @for (validation of validationMessages.adr2; track validation) {
              <span>
                @if (form1.get('adr2').hasError(validation.type) && (form1.get('adr2').dirty || form1.get('adr2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCity" id="adrCity" type="text" pInputText>
            <label for="adrCity">City</label>
            @for (validation of validationMessages.adrCity; track validation) {
              <span>
                @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="states" formControlName="adrState" appendTo="body" optionLabel="name" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select State"></p-dropdown>
            <label for="Select State">Select State</label>
            @for (validation of validationMessages.adrState; track validation) {
              <span>
                @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="adrCountry" appendTo="body" optionLabel="name" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select Country"></p-dropdown>
            <label for="Select Country">Select Country</label>
            @for (validation of validationMessages.adrCountry; track validation) {
              <span>
                @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
            <label for="adrPostalCode">Postal Code</label>
            @for (validation of validationMessages.adrPostalCode; track validation) {
              <span>
                @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrIsland" id="adrIsland" type="text" pInputText>
            <label for="adrIsland">Island</label>
            @for (validation of validationMessages.adrIsland; track validation) {
              <span>
                @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty || form1.get('adrIsland').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="salaryRange" id="salaryRange" [rows]="2" pInputTextarea></textarea>
            <label for="salaryRange">Salary Range</label>
            @for (validation of validationMessages.salaryRange; track validation) {
              <span>
                @if (form1.get('salaryRange').hasError(validation.type) && (form1.get('salaryRange').dirty || form1.get('salaryRange').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (jobId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Job</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!jobId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Job</button>
              }

              @if (jobId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Job</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>